import UserProfileDetailsTab from './UserProfileDetailsTab'

export default UserProfileDetailsTab
